const vouchersTypes = {

  get: {
    request: "GET_VOUCHER_REQUEST",
    success: "GET_VOUCHER_SUCCESS",
    failure: "GET_VOUCHER_FAILURE"
  },

  index: {
    request: "VOUCHERS_INDEX_REQUEST",
    success: "VOUCHERS_INDEX_SUCCESS",
    failure: "VOUCHERS_INDEX_FAILURE",
    select:  "VOUCHERS_INDEX_SELECT"
  },

  create: {
    init:    "CREATE_VOUCHER_INIT",
    request: "CREATE_VOUCHER_REQUEST",
    success: "CREATE_VOUCHER_SUCCESS",
    failure: "CREATE_VOUCHER_FAILURE"
  },

  update: {
    request: "UPDATE_VOUCHER_REQUEST",
    success: "UPDATE_VOUCHER_SUCCESS",
    failure: "UPDATE_VOUCHER_FAILURE"
  },

  publish: {
    request: "VOUCHER_OPERATION_REQUEST",
    success: "VOUCHER_OPERATION_SUCCESS",
    single: "VOUCHER_OPERATION_SINGLE_SUCCESS",
    failure: "VOUCHER_OPERATION_FAILURE"
  },

  autofill: {
    request: "VOUCHER_AUTOFILL_REQUEST",
    success: "VOUCHER_AUTOFILL_SUCCESS",
    failure: "VOUCHER_AUTOFILL_FAILURE",
    clear: "VOUCHER_AUTOFILL_CLEAR",
  },

  set_errors: "SET_VOUCHER_ERRORS",

  reset_voucher: "RESET_VOUCHER",

  clear_voucher: "CLEAR_VOUCHER",

}

export default vouchersTypes



// WEBPACK FOOTER //
// ./src/js/constants/vouchersTypes.js